import React from "react";

import {
  About,
  Navbar,
  Projects,
  Skills,
  Contact,
  // eslint-disable-next-line
  Testimonials,
  Certifications,
} from "./components";

export default function App() {
  return (
    <main className='text-gray-400 bg-gray-800 min-h-screen body-font'>
      <Navbar />
      <About />
      <Certifications />
      <Projects />
      <Skills />
      <Contact />
    </main>
  );
}
